(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["una-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-una-rail]');
  if (!btn) return;
  var wrap = btn.closest('.una-carousel');
  var rail = wrap && wrap.querySelector('[data-una-railtrack]');
  if (!rail) return;
  var dir = btn.getAttribute('data-una-rail') === 'prev' ? -1 : 1;
  rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["una-work"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-una-play]');
  if (!btn) return;
  var wrap = btn.closest('[data-una-film]');
  if (!wrap) return;
  var poster = wrap.querySelector('.una-film-poster');
  var player = wrap.querySelector('.una-film-player');
  var video = player && player.querySelector('video');
  if (!player || !video) return;
  player.hidden = false;
  if (poster) poster.hidden = true;
  var p = video.play();
  if (p && p.catch) p.catch(function () {});
});

  } catch(e) { console.error(e); }
})();
})();
